import type { TFunction } from 'i18next';
import {
  AccommodationUnitPattern,
  PlaceholderCostType,
  PlaceholderStatus,
  PlaceholderType,
  TransportKind,
} from '@/api/generated/schemas';

/** Jedna volba segmentovaného přepínače / enum filtru — hodnota enumu + lokalizovaný popisek. */
export interface EnumOption<T extends string = string> {
  value: T;
  label: string;
}

/** Typy placeholderu (5) → lokalizované volby. */
export function placeholderTypeOptions(t: TFunction): EnumOption<PlaceholderType>[] {
  return [
    { value: PlaceholderType.Accommodation, label: t('schemes.enums.type.Accommodation') },
    { value: PlaceholderType.Transport, label: t('schemes.enums.type.Transport') },
    { value: PlaceholderType.Activities, label: t('schemes.enums.type.Activities') },
    { value: PlaceholderType.LocalGuides, label: t('schemes.enums.type.LocalGuides') },
    { value: PlaceholderType.OtherServices, label: t('schemes.enums.type.OtherServices') },
  ];
}

/** Typy nákladu (3) → lokalizované volby. */
export function placeholderCostTypeOptions(t: TFunction): EnumOption<PlaceholderCostType>[] {
  return [
    { value: PlaceholderCostType.Calculation, label: t('schemes.enums.costType.Calculation') },
    { value: PlaceholderCostType.Onsite, label: t('schemes.enums.costType.Onsite') },
    { value: PlaceholderCostType.None, label: t('schemes.enums.costType.None') },
  ];
}

/** Stavy (2) → lokalizované volby. */
export function placeholderStatusOptions(t: TFunction): EnumOption<PlaceholderStatus>[] {
  return [
    { value: PlaceholderStatus.Active, label: t('schemes.enums.status.Active') },
    { value: PlaceholderStatus.Archived, label: t('schemes.enums.status.Archived') },
  ];
}

/** Druhy dopravy (3) → lokalizované volby. */
export function transportKindOptions(t: TFunction): EnumOption<TransportKind>[] {
  return [
    { value: TransportKind.Bus, label: t('schemes.enums.transportKind.Bus') },
    { value: TransportKind.Boat, label: t('schemes.enums.transportKind.Boat') },
    { value: TransportKind.Train, label: t('schemes.enums.transportKind.Train') },
  ];
}

/** Vzory obsazení pokoje (4) → lokalizované volby (unit patterns). */
export function unitPatternOptions(t: TFunction): EnumOption<AccommodationUnitPattern>[] {
  return [
    { value: AccommodationUnitPattern.Single, label: t('schemes.enums.unitPattern.Single') },
    { value: AccommodationUnitPattern.Double, label: t('schemes.enums.unitPattern.Double') },
    { value: AccommodationUnitPattern.Triple, label: t('schemes.enums.unitPattern.Triple') },
    { value: AccommodationUnitPattern.Quad, label: t('schemes.enums.unitPattern.Quad') },
  ];
}

/** Nápověda k typu nákladu (pod segmentovaným přepínačem) — vysvětlí význam volby. */
export function costTypeHint(t: TFunction, costType: PlaceholderCostType): string {
  switch (costType) {
    case PlaceholderCostType.Calculation:
      return t('schemes.enums.costTypeHint.Calculation');
    case PlaceholderCostType.Onsite:
      return t('schemes.enums.costTypeHint.Onsite');
    case PlaceholderCostType.None:
      return t('schemes.enums.costTypeHint.None');
    default:
      return '';
  }
}

/** Tón badge stavu pro sloupce ListPage. */
export function statusTone(status: PlaceholderStatus): 'success' | 'neutral' {
  return status === PlaceholderStatus.Active ? 'success' : 'neutral';
}
